module.exports = __webpack_public_path__ + "static/media/apple_podcasts.a9810f8b.svg";